import React, { useState } from 'react';
import './Case.css';
import CaseDetail from './CaseDetail';

const Case = ({ caseItem, balance, onOpenBalanceModal, onAddStars }) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  const openDetail = () => setIsDetailOpen(true);
  const closeDetail = () => setIsDetailOpen(false);

  return (
    <>
      <div className="case-card-nova" onClick={openDetail}>
        <div className="case-image-container">
          <img src={`/cases/${caseItem.image}`} alt={caseItem.name} className="case-image-nova" />
        </div>
        <div className="case-info-nova">
          <h3 className="case-name-nova">{caseItem.name}</h3>
          <div className="case-prices-bar">
            <div className="case-price-pill stars-pill">
              <img src="/icons/stars-symbol.png" alt="stars" className="case-star-icon-nova" style={{width: 18, height: 18}} /> {caseItem.price}
            </div>
            <div className="case-price-pill ton-pill">
              <img src="/icons/ton_symbol.png" alt="TON" className="case-ton-icon" />
              {caseItem.tonPrice}
            </div>
          </div>
        </div>
      </div>
      {isDetailOpen && (
        <div className="modal-overlay" onClick={closeDetail}>
           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
             <button className="modal-close-btn" onClick={closeDetail}>&times;</button>
            <CaseDetail 
              caseItem={caseItem} 
              onClose={closeDetail}
              balance={balance}
              onOpenBalanceModal={onOpenBalanceModal}
              onAddStars={onAddStars}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Case; 